import React, { Suspense } from "react";
import { storyblokEditable } from "@storyblok/react/rsc";
import { fetchContentType } from "@/lib/storyblok_utils";
import FaqAccordionClient from "./FaqAccordionClient";
import { FaqStoryblok } from "@/component-types-sb";

interface FaqAccordionProps {
  blok: FaqStoryblok;
  data?: {
    version?: "draft" | "published";
  };
}

const FaqAccordionAsync = async ({
  blok,
  version,
}: {
  blok: FaqStoryblok;
  version: "draft" | "published";
}) => {
  const queryResult = await fetchContentType(
    "faq/",
    version,
    undefined,
    undefined,
    undefined,
    "faq_entry"
  );

  return <FaqAccordionClient blok={blok} initialQueryResult={queryResult} />;
};

const FaqAccordion: React.FC<FaqAccordionProps> = ({ blok, data }) => {
  const version = data?.version ?? "published";

  return (
    <div {...storyblokEditable(blok)}>
      <Suspense fallback={<p className="text-sm text-gray-500">Loading FAQs...</p>}>
        <FaqAccordionAsync blok={blok} version={version} />
      </Suspense>
    </div>
  );
};

export default FaqAccordion;
